// import React from 'react';
import React, { useEffect, useRef, useState } from 'react';
import "./Home2024.css"
import "../BuyNow/BuyNow.css"
import "./Home.css"
import { Link, NavLink } from "react-router-dom";
import Popup from '../../Components/Popup/Popup';
import img01 from '../../Images/2024/EV_026.webp'
import img02 from '../../Images/2024/EV_038.webp'
import img03 from '../../Images/2024/EV_040.webp'
import img04 from '../../Images/2024/EV_021.webp'
import img05 from '../../Images/2024/EV_018.webp'
import img06 from '../../Images/2024/EV_037.webp'
import img07 from '../../Images/2024/EV_001.webp'
import img08 from '../../Images/2024/EV_023.webp'
import img09 from '../../Images/2024/IN_004.webp'
import img10 from '../../Images/2024/IN_009.webp'
import 'swiper/css';
import ImageSlider from '../../Components/ImageSlider/ImageSlider';
import { MdExpandMore, MdOutlineArrowOutward } from "react-icons/md";
import HarmonyTree from '../../Images/Mandli/Harmony_Tree.svg'
import GroundImage from '../../Images/Mandli/Ground_image.svg'
import faqsMountains from '../../Images/Mandli/FaqsMountain.svg'
import DrumBanner from '../../Images/Mandli/Drum_Banner.svg'
import mandliLogo from '../../Images/Mandli/Mandli_White_Red_logo.svg'
import district_btn from '../../Images/Mandli/district_btn.svg'
import View_Gallery from '../../Images/Mandli/View_Gallery.svg'
import Drum_mobile from '../../Images/Mandli/Drum_mobile.svg'
import HarmonyTreeMobile from '../../Images/Mandli/Harmony_Tree_mobile.svg'
import GroundImageMobile from '../../Images/Mandli/Ground_image_mobile.svg'
import faqsMountainsMobile from '../../Images/Mandli/faqsMountainsMobile.svg'
import sticky_district_button from '../../Images/Mandli/sticky_district_button.svg'
import { HiArrowSmallRight } from "react-icons/hi2";

function Home2024() {

	// useEffect(() => {
	//   window.scrollTo(0, 0)
	// }, [])

	// faq

	// useEffect(() => {
	// 	const answers = document.querySelectorAll('.faq-ans');
	// 	answers.forEach((answer, idx) => {
	// 		if (idx === activeIndex) {
	// 			answer.style.height = answer.scrollHeight + 'px';
	// 		} else {
	// 			answer.style.height = '0';
	// 		}
	// 	});
	// }, [activeIndex]);

	// Function to toggle the FAQ visibility
	// const toggleFAQ = (index) => {
	// 	if (activeIndex === index) {
	// 		const answer = document.querySelector(`.faq-ans[data-index="${index}"]`);
	// 		answer.style.height = answer.scrollHeight + 'px';
	// 		setTimeout(() => {
	// 			answer.style.height = '0';
	// 		}, 300);
	// 		setActiveIndex(null);
	// 	} else {
	// 		setActiveIndex(index);
	// 	}
	// };

	const [activeIndex, setActiveIndex] = useState(null);

	const accordionData = [
		{
			question: "Where do I find my purchased passes?",
			answer: "You can find your purchased passes in the 'My Account' section under 'Purchased Items'. They'll be listed with their activation status and expiry dates."
		},
		{
			question: "How to download purchased passes?",
			answer: "Go to your account dashboard, select the pass you want to download, and click the 'Download' button. The pass will be saved as a PDF or digital wallet item."
		},
		{
			question: "What is the last date for buying the seasonal passes?",
			answer: "Seasonal passes are typically available until the end of each season. Check the specific pass details for exact cutoff dates, usually around 2-4 weeks before season end."
		},
		{
			question: "How to avail discount?",
			answer: "Discounts can be applied using promo codes at checkout, through student/military verification, or by purchasing bundle deals. Check our promotions page for current offers."
		}
	];

	const toggleAccordion = (index) => {
		setActiveIndex(activeIndex === index ? null : index);
	};

	const useWindowWidth = () => {
		const [windowWidth, setWindowWidth] = useState(window.innerWidth);

		useEffect(() => {
			const handleResize = () => setWindowWidth(window.innerWidth);
			window.addEventListener('resize', handleResize);
			return () => window.removeEventListener('resize', handleResize);
		}, []);

		return windowWidth;
	};

	const width = useWindowWidth();

	const [showStickyBtn, setShowStickyBtn] = useState(false);
	const targetRef = useRef(null);

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => setShowStickyBtn(!entry.isIntersecting),
			{ threshold: 0 }
		);

		if (targetRef.current) {
			observer.observe(targetRef.current);
		}

		return () => {
			if (targetRef.current) {
				observer.unobserve(targetRef.current);
			}
		};
	}, []);

	return (
		<div className='Home2024'>
			<Popup />


			<section className="section banner " id="banner">
				<div className="drum-banner">
					<img className="mandli-logo " src={mandliLogo} alt="image" />

					<div className='drum-banner-content'>
						<div className="drum-banner-img banner-wrapper main-heading what_is_mandli">
							<img className='hideinmobile' src={DrumBanner} alt="banner" />
							<img className='hideInDesktop drum-banner-mobile' src={Drum_mobile} alt="banner" />
							<div className="dates-section dates-section-mobile">
								<div className='fonts_and_venue'>
									<h2 className="banner-fonts and-fonts">dates <span>&</span> venue</h2>
									<div className='date_venue_css'>
										<div className="dates_css">
											<div>11th Oct to 19th Oct, 2026 <br /> 8 pm onwards</div>
										</div>
										<div className='footer-divider-banner'></div>
										<div className='venue_css'>
											{/* <div>Venue to be announced soon</div> */}
											<div>
												<a href="https://maps.app.goo.gl/29ETRpjBUv68kvNs8" target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: "none" }}>
													<span style={{ textDecoration: "underline", textUnderlineOffset: "4px" }}>Mandli Garba, Kalol Road, Rancharda, </span>
													<span style={{ whiteSpace: 'nowrap' }}>
														<span style={{ textDecoration: "underline", textUnderlineOffset: "4px" }}>Ahmedabad</span>
														<HiArrowSmallRight className='arrow-right' style={{ marginBottom: "-2px", marginLeft: "0px" }} />
													</span>
												</a>
											</div>
										</div>
									</div>
								</div>

								<div className='fonts_and_venue'>
									<div className="banner-wrapper main-heading what_is_mandli">
										{/* <h2 className="banner-fonts-smaller and-fonts"> book passes<span> on</span> </h2>

										<a href="https://link.district.in/DSTRKT/MandliGarbaAhmedabadPartnerSocial" target="_blank">
											<img src={district_btn} className='district-book-btn' alt="book on district" />
										</a> */}
										<h2 ref={targetRef} className="banner-fonts-smaller and-fonts pb-3" style={{ marginTop: width > 768 ? "-100px" : "20px" }}>Tickets Coming soon</h2>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
			</section>


			<section className='section about-section ' id='Whatismandli'>
				<div className='harmony_css'>
					<div className='row'>
						<div className='container-custom main-heading what_is_mandli_yellow'>
							<h2 className="and-fonts-yellow"> <span>the </span>harmony</h2>
							<p className='ind_text_swd lineheight-spc lh-base'>We believe in building a celebration that exists in harmony with its surroundings. Like the trees that anchor our space, our brand is rooted in empathy, redesigning the environment not by replacing it, but by weaving its natural beauty into our design. We are committed to leaving every ecosystem we touch not just unharmed, but enhanced.</p>
						</div>
					</div>
					<div className='row2'>
						<img className='hideinmobile' src={HarmonyTree} alt="" />
						<img className='hideInDesktop' src={HarmonyTreeMobile} alt="" />
					</div>
				</div>
			</section >

			<section className='section about-section  ground-css-main' id='Whatismandli'>
				<div className='ground_css'>
					<div className='row'>
						<div className='container-custom main-heading what_is_mandli_red'>
							<h2 className="and-fonts-red fonts-ground"> <span>the </span>celebration</h2>
							<p className='ind_text_swd lineheight-spc lh-base'>Celebration is a sacred and hard-earned value at Mandli. Just as the spider rebuilds its web with unwavering focus, we dedicate ourselves to building the Mandli experience each year. This unwavering commitment is driven by one purpose: to provide a vibrant, safe, and authentic space where our community can come together and lose themselves in the pure joy of Navratri.</p>
						</div>
					</div>

					<div className='row2'>
						<img className='hideinmobile' src={GroundImage} alt="" />
						<img className='hideInDesktop' src={GroundImageMobile} alt="" />
					</div>

				</div>
			</section >


			<section className='section formats-section slider-sec' id='galleryog'>
				<div className='harmony_css'>
					<div className='row'>
						<div className={`${width > 769 ? 'container' : 'no-container'}`}>
							<div className="addpsaceIndesktop addSpaceInMobile">
								<div className='main-heading what_is_mandli_slider'>
									<h2 className="and-fonts-yellow fonts-slider">
										<span>mandli </span>memories
									</h2>
								</div>
								<div className={`image-gallry ${width > 769 ? 'container' : 'no-container'}`}>
									<ImageSlider
										images={[img01, img02, img03, img04, img05, img06, img07, img08, img09, img10]}
										slidesToShowDesktop={3}
										slidesToShowTablet={3}
										slidesToShowMobile={1}
									/>
								</div>
							</div>
						</div>

						<div className='main-heading high-z-index mt-5'>
							<div className='new-btn-style'>
								<NavLink className="view-gallery_button white big cst-font-size gallry_filed og-font-style" to="/gallery">
									<img className='view-gallery-img' src={View_Gallery} alt="" />
								</NavLink>
							</div>
						</div>
					</div>
					{/* background image shifted up */}
					<div className='row2'>
						<img className='hideinmobile' src={faqsMountains} alt="" />
						<img className='hideInDesktop' src={faqsMountainsMobile} alt="" />
					</div>
				</div>
			</section>

			<section className='faqs-section-main'>
				<div className='faqs-section'>
					<div className='container-custom main-heading what_is_mandli_red center-celebration'>
						<h2 className="and-fonts-red fonts-ground"> <span>frequently </span>asked <br className='hideInDesktop' />questions</h2>
					</div>

					<div className="accordion-container">
						{accordionData.map((item, index) => (
							<div key={index} className="accordion-item">
								<div
									className={`accordion-header ${activeIndex === index ? 'active' : ''}`}
									onClick={() => toggleAccordion(index)}
								>
									<h3 className="accordion-title">{item.question}</h3>
									<span className={`accordion-icon ${activeIndex === index ? 'rotated' : ''}`}>
										<MdExpandMore />
									</span>
								</div>
								<div className={`accordion-content ${activeIndex === index ? 'open' : ''}`}>
									<div className="accordion-text">
										{item.answer}
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</section >


			{/* <section className='faqs-sec'>
        <div className='container'>
          <div className="addpsaceIndesktop">
            <h2 className="and-fonts">Frequently Asked Questions</h2>
            <div className="mobile-faq-container">
              {getFaqsList.map((faq, index) => (
                <div
                  className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                  key={index}
                  onClick={() => toggleFAQ(index)}
                >
                  <div className="faq-question">
                    {faq.question}
                    <span className={`arrow ${activeIndex === index ? 'rotate' : ''}`}>
                      <IoChevronDown />
                    </span>
                  </div>
                  <div className="faq-ans" data-index={index} >
                    <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section> */}
			{/* {showStickyBtn &&
				<a href="https://link.district.in/DSTRKT/MandliGarbaAhmedabadPartnerSocial" target="_blank">
					<img
						src={sticky_district_button}
						alt="Book Passes"
						className="sticky-district-btn"
					/>
				</a>
			} */}
		</div >
	)
}

export default Home2024